// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__ycbtL","slide-in-bottom":"tooltip_slide-in-bottom__0vxvf"};